var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3812FB81-87F1-4F3C-BD90-803475CDB18F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Richr-Money",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "ConnectBankAccount_NotConnected_Intro_PopUp",
    transform: "translate(-530.000000, -30.000000)",
    fill: "#0AAFED",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.529037,38.1174223 L522.411615,33 L527.529037,27.8825777 C528.156988,27.2546273 528.156988,26.2361181 527.529037,25.6081677 L526.391832,24.4709628 C525.763882,23.8430124 524.745373,23.8430124 524.117422,24.4709628 L519,29.5883851 L513.882578,24.4709628 C513.254627,23.8430124 512.236118,23.8430124 511.608168,24.4709628 L510.470963,25.6081677 C509.843012,26.2361181 509.843012,27.2546273 510.470963,27.8825777 L515.588385,33 L510.470963,38.1174223 C509.843012,38.7453727 509.843012,39.7638819 510.470963,40.3918323 L511.608168,41.5290372 C512.236118,42.1569876 513.254627,42.1569876 513.882578,41.5290372 L519,36.4116149 L524.117422,41.5290372 C524.745373,42.1569876 525.763882,42.1569876 526.391832,41.5290372 L527.529037,40.3918323 C528.156988,39.7638819 528.156988,38.7453727 527.529037,38.1174223 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.474813ee441af2878cd6b0b04cb4708e.svg";
export { ForwardRef as ReactComponent };